<script>

    let dialog;

    export const show = () => {
        dialog.showModal();
    }
    export const hide = () => {
        dialog.close();
    }

</script>

<dialog bind:this={dialog}>
    <slot></slot>
</dialog>

<style>
    dialog {
        position: relative;
    }
</style>